import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import { Text } from 'foundations-components/components/Text';
import ApplyPresetFooter from './ApplyPresetFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import * as PresetActions from '../../actions/PresetActions';
import { Flex } from 'foundations-components/components/Flex';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/transitional/components/View';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PresetListPanel = ({
  activeThemePresetId,
  onClose,
  presets,
  presetsRequestStatus: __presetsRequestStatus,
  selectedThemePresetId,
  themePath
}) => {
  const dispatch = useDispatch();
  const [isApplyPresetFooterOpen, setIsApplyPresetFooterOpen] = useState(false);
  const [isApplyingPreset, setIsApplyingPreset] = useState(false);
  const clearPreset = () => {
    dispatch(PresetActions.clearPreset());
  };
  const selectPreset = presetId => {
    dispatch(PresetActions.selectPreset(presetId));
  };
  const handleSelectPreset = presetId => {
    setIsApplyPresetFooterOpen(true);
    if (presetId) {
      selectPreset(presetId);
    } else {
      clearPreset();
    }
  };
  const handleApplyPreset = () => {
    setIsApplyingPreset(true);
    dispatch(PresetActions.applyPreset(themePath, selectedThemePresetId)).then(() => {
      setIsApplyingPreset(false);
      onClose();
    }).catch(err => {
      setIsApplyingPreset(false);
      setTimeout(() => {
        throw err;
      });
    });
  };

  // Restore previously selected preset or clear if none was previously selected
  const handleCancel = () => {
    if (selectedThemePresetId !== activeThemePresetId) {
      if (activeThemePresetId) {
        selectPreset(activeThemePresetId);
      } else {
        clearPreset();
      }
    }
    setIsApplyPresetFooterOpen(false);
  };
  const handleCancelAndClose = () => {
    handleCancel();
    onClose();
  };
  return /*#__PURE__*/_jsxs(Flex, {
    blockSize: "100%",
    flexDirection: "column",
    justifyContent: "space-between",
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      overflowY: "auto",
      padding: "500",
      children: [/*#__PURE__*/_jsx(View, {
        children: /*#__PURE__*/_jsx(Breadcrumbs, {
          flush: true,
          marginBlockStart: "0",
          marginBlockEnd: "500",
          children: /*#__PURE__*/_jsx(Link, {
            onClick: handleCancelAndClose,
            children: "Back"
          })
        })
      }), /*#__PURE__*/_jsxs(List, {
        children: [/*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(SelectableBox, {
            selected: !selectedThemePresetId,
            type: "default",
            onClick: () => handleSelectPreset(),
            marginBlockEnd: "300",
            children: /*#__PURE__*/_jsx(Text, {
              children: "Use theme defaults"
            })
          })
        }), presets.map((preset, index) => /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(SelectableBox, {
            selected: selectedThemePresetId === preset.id,
            type: "default",
            onClick: () => handleSelectPreset(preset.id),
            marginBlockEnd: "300",
            children: /*#__PURE__*/_jsx(Text, {
              children: preset.name
            })
          })
        }, index))]
      })]
    }), /*#__PURE__*/_jsxs(ApplyPresetFooter, {
      isOpen: isApplyPresetFooterOpen,
      onOpenComplete: () => {
        setIsApplyPresetFooterOpen(true);
      },
      children: [/*#__PURE__*/_jsx(LoadingButton, {
        loading: isApplyingPreset,
        onClick: handleApplyPreset,
        use: "primary",
        children: "Apply"
      }), /*#__PURE__*/_jsx(Button, {
        onClick: handleCancel,
        use: "secondary",
        children: "Cancel"
      })]
    })]
  });
};
export default PresetListPanel;